// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__ztkyG","footer":"ModalError_footer__GnBzg"};